<template>
   <v-icon
      v-if="!state"
      :disabled="disabled" 
      color="#0f74bb"
      @click="downloadLogFile(item)">
      mdi-download
    </v-icon>
    <v-progress-circular
      v-else
      :size="20"
      color="primary"
      indeterminate
    ></v-progress-circular>
</template>

<script>

import { DownloadFile, GetLogContent } from "@/services/file-retrieval.js"

import { AmplifyEventBus } from "aws-amplify-vue";

// import { Logger } from "aws-amplify";
// const logger = new Logger("Download Log Comp");

export default {
  name: 'DownloadButton',
  props: {
    item: {
      type: Object,
      required: true
    },
    orgId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      state: false
    }
  },
  computed: {
    disabled() {
      return this.item.status == 'Success' ? false : true;
    }
  },
  methods: {
    async downloadLogFile(item) {
      this.state = true;
      
      let file = await DownloadFile(this.orgId, item.file_request_id);

      if (file.location) {
        let contents = await GetLogContent(file.location);
        let blob = new Blob([contents], {type: 'text'});

        const elem = window.document.createElement('a');
        let fileName = `${this.item.vehicle_name}_${this.item.description}.log`;
        elem.href = window.URL.createObjectURL(blob);
        elem.download = fileName;    
        document.body.appendChild(elem);
        elem.click();        
        document.body.removeChild(elem);

        this.state = false;
      } else {
        AmplifyEventBus.$emit("snackEvent", {
          color: "error",
          text: 'File not found.',
        });
        this.state = false;
      }
    },
  }
}
</script>